import gql from "graphql-tag";

export const CLIENT_MEDICAL_ASSESSMENT_QUERY = gql`
  query medicalAssessment($userId: ID!) {
    medicalAssessment(userId: $userId) {
      id
      assessmentDate
      age
      heartCondition
      highBloodPressure
      chestPain
      dizziness
      backNeckPain
      backNeckPainNotes
      chronicCondition
      chronicConditionNotes
      arthritis
      arthritisNotes
      softTissueProblem
      softTissueProblemNotes
      recentInjury
      recentInjuryNotes
      thyroidHormonalProblem
      thyroidHormonalProblemNotes
      hasHadCovid19
      medicallySupervised
      prescribedMedication
      prescribedMedicationNotes
      possiblyPregnant
      pregnantWeeks
      recentBaby
      recentBabyWeeks
      otherInjuries
      reasonsToNotExercise
      clearedByProfessional
      occupation
      dailyRoutine
      spousalDetails
      childrenDetails
      foodAllergies
      nutritionalHabitRating
      nutritionalKnowledgeRating
      previousSuccessfulDiets
      nutritionalTriggers
      specialDiet
      externalShopper
      exerciseHistory
      bestWeight
      currentJeanSize

      levelOfStress
      handleStress
      qualityOfSleep
      lackOfMotivation
      lackOfEnergy
      lackOfConsistency
      injury
      whatTypeOfExercise
      certainExercisesProperly
      enoughTimeToExercise
      whatToEat
      howMuchToEat
      planningMeals
      enoughTimeToCook
      howToCook
      foodCravings
      eatingPoorly
      alwaysHungry
      overEating
      weekendWobbles
      culturalChallenges
      regularlyCycling
      excessiveAlcohol
      jointPain
      musculoskeletalSurgery
      levelOfFitness
      hiking
      running
      swimming
      strengthTraining
      intensityTraining
      workingOutAtHome
      workingOutAtGym
      yoga
      pilates
      cycling
      otherTeamSports
      otherIndividualSports
      enjoyWorking
      dailyHydration

      coachNotes {
        id
        createdAt
        coach {
          id
          firstName
          lastName
        }
        column
        note
      }
    }
  }
`;

export const ADD_COACH_MEDICAL_ASSESSMENT_NOTE_MUTATION = gql`
  mutation addCoachMedicalAssessmentNote($input: CoachMedicalAssessmentNoteInput!) {
    addCoachMedicalAssessmentNote(input: $input) {
      success
      error
    }
  }
`;
